import { createFileRoute } from '@tanstack/react-router'
import { QrAnalyticsScreen } from '@/components/analytics/qr-analytics-screen'
import { AnalyticsSkeleton } from '@/components/shell/screen-skeletons'

/**
 * The mobile Analytics tab. On desktop the same summary lives in the control
 * panel's left pane, which is why this route is hidden there rather than
 * duplicated — one component, two placements.
 */
export const Route = createFileRoute('/o/$org/qr-codes/$id/analytics')({
  pendingComponent: AnalyticsSkeleton,
  component: QrAnalyticsRoute,
})

function QrAnalyticsRoute() {
  const { id } = Route.useParams()
  return <QrAnalyticsScreen constellationId={id} />
}
